import { all } from "redux-saga/effects";
import createSale from "./createSale";
import fetchSales from "./fetchSales";
import createOrder from "./createOrder";
import fetchOrders from "./fetchOrders";
import fetchMoneyEntries from "./fetchMoneyEntries";
import createTransfer from "./createTransfer";
import fetchTransfers from "./fetchTransfers";
import fetchMarketPrice from "./fetchMarketPrice";
import createAddMoney from "./createAddMoney";
import cancelOrder from "./cancelOrder";
import cancelSale from "./cancelSale";

export default function* rootSaga(): Generator {
    yield all([
        createSale(),
        fetchSales(),
        createOrder(),
        fetchOrders(),
        fetchMoneyEntries(),
        createTransfer(),
        fetchTransfers(),
        fetchMarketPrice(),
        createAddMoney(),
        cancelOrder(),
        cancelSale(),
    ]);
}
